<template>
	<header class="header"
			:class="{'header__events': background === 'events', 'header__event': background === 'event', 'header__judges': background === 'judges', 'header__account': background === 'account'}">
		<div class="container">
			<h2 class="header__headline" :class="{'header__headline--black': black, 'header__headline--events': background === 'events'}">
				<slot name="title"></slot>
			</h2>
		</div>
	</header>
</template>

<script>
	export default {
		props: ['background', 'black']
	}
</script>

<style lang="scss" scoped>
	@import "../styles/variables.scss";

	.header {
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		padding: 65px 0 50px;
		&__events {
			background-image: url("/static/img/events-bg.jpg");
		}
		&__event {
			background-image: url("/static/img/event-bg.jpg");
		}
		&__judges {
			background-image: url("/static/img/judges-bg.jpg");
		}
		&__account {
			background-image: url("/static/img/account-bg.jpg");
		}
		&__headline {
			margin: 0;
			margin-left: -3px;
			text-align: left;
			padding-left: 200px;
			font-family: $libre-bold;
			color: $gold-dark;
			text-transform: capitalize;
			font-size: 60px;
			letter-spacing: 0.05em;
			text-transform: capitalize;
			&--black {
				color: $black;
			}
		}
	}

	@media (max-width: 991.98px) {
		.header {
			padding: 30px 0;
			&__events {
				background: #222223;
			}
			&__judges {
				background: #222223;
			}
			&__account {
				background: #222223;
			}
			&__headline {
				font-size: 26px;
				color: $gold-dark;
				padding-left: 0;
				&--black {
					color: $gold-dark;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/ListHeaderComponent.vue